<template>
    <div class="small_modal_wrap" >
        <div class="small_modal_back" @click="hide" :style="{opacity:opacity}"></div>
        <div class="small_modal_contents_wrap" @click="$event.stopPropagation(); hide()">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SmallModal",
        props : ['hide', 'mode'],
        data : function(){
            return {
                opacity : 0.5
            }
        },
        methods : {

        },
        created : function(){
            if(this.mode == 'noColor'){
                this.opacity = 0;
            }
        }
    }
</script>

<style scoped>
    .small_modal_wrap{position:relative; z-index:1000;}
    .small_modal_back{
        position:fixed;
        width:100%;
        height:100%;
        top:0px;
        left:0px;
        background-color: black;
        opacity:0.5;
    }

    .small_modal_contents_wrap{
        position:fixed;
        width:100%;
        height:100%;
        top:0px;
        left:0px;
        display:flex;
        justify-content: center;
        align-items: center;
    }
</style>